import { get } from "../../api";

const getType = (typeId, headers) =>
  get("getType", headers, `?typeId=${typeId}`);

export { getType };



// WEBPACK FOOTER //
// ./src/stores/GetTypeStore/services.js